import { useTranslation } from 'react-i18next'
import OpportunityKeywordsController from './opportunityKeywordsController'
import OpportunityKeywordsModel from './opportunityKeywordsModel'
import PaperItem from '../../../components/Essential/PaperItem'
import { Box, Button, Grid2, MenuItem, Select, TextField, Typography } from '@mui/material'
import ButtonGroup from '../../../components/ButtonGroup/ButtonGroup'
import Filter from '../../../components/Filter/Filter'
import * as CONSTANTS from '../../../utils/Constants'
import { FILTER_CLICKS, FILTER_CTR, FILTER_POSITIONS, FILTER_VOLUME } from '../../../utils/Constants'
import TableComponent from '../../../components/TableComponent'
import { COLUMNS_PROJECT_OPPORTUNITY_KEYWORD } from '../../../utils/TableColumnsConstants'
import { extractRootDomain } from '../../../utils/Utils'
import * as React from 'react'
import DateRangeSelectorView from '../../../components/Selectors/DateRangeSelector/DateRangeSelectorView'
import ButtonExportExcel from '../../../components/Buttons/ExportExcel'

const OpportunityKeywordsView = () => {
  const { t } = useTranslation()

  const model = OpportunityKeywordsModel();
  const controller = OpportunityKeywordsController(model);


  return (
    <Grid2 container spacing={2} className='container-analysis'>
      <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <PaperItem className='flex-col gap-2 boxShadow' sx={{ p: 3 }}>

          <Select variant={'outlined'} value={model.projectSelected || ''}
                  onChange={(event) => {
                    model.setProjectSelected(event.target.value)
                    model.setUrl(event.target.value.replace('sc-domain:','https://'))
                  }}
                  displayEmpty
                  fullWidth
                  className={'projectSelector'}
                  MenuProps={{ disableScrollLock: true }}
          >
            <MenuItem value="" disabled style={{ display: 'none' }} >{t('project')}</MenuItem>

            {model.projectsData && (
              model.projectsData
                .sort((a, b) => extractRootDomain(a.property).localeCompare(extractRootDomain(b.property)))
                .map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.property}>
                      <img
                        src={`https://www.google.com/s2/favicons?sz=32&domain=${extractRootDomain(item.property) || 'example.com'}`}
                        loading="lazy"
                        alt="favicon"
                        width={20}
                        height={20}
                        style={{ borderRadius: '50%', marginRight: '10px', verticalAlign: 'bottom' }}
                      />
                      <span>{extractRootDomain(item.property)}</span>
                    </MenuItem>
                  );
                })
            )}
          </Select>

          <TextField focused={true} value={model.url || ''} fullWidth
                     label="URL"
                     size="small"
                     disabled={model.url === undefined}
                     placeholder={t('the_url_must_have_the_domain')}
                     onChange={(e) => model.setUrl(e.target.value)}
                     className={'url'}
          />

          <div className='flex gap-2 w-full pt-3' >
            { /*<KeywordsFilters />*/}
            <Filter name='clicks' items={FILTER_CLICKS} custom={true} onChange={controller.handleFilterUpdate} />
            <Filter name='impressions' items={FILTER_CLICKS} custom={true} onChange={controller.handleFilterUpdate} />
            <Filter name='position' items={FILTER_POSITIONS} custom={true} onChange={controller.handleFilterUpdate} />
            <Filter name='ctr' items={FILTER_CTR} custom={true} onChange={controller.handleFilterUpdate} />
            <DateRangeSelectorView onChange={controller.handleFilterUpdate} />
          </div>

          <div className="flex justify-end">
            <Button
              color="primary"
              variant="contained"
              onClick={controller.handleSearchBtn}
              disabled={!model.url}
            >
              {t('obtain')}
            </Button>
          </div>
        </PaperItem>
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <PaperItem className='boxShadow' sx={{ p: 3 }}>

          <Box display="flex" justifyContent="space-between" alignItems="center" mb={0}>
            <Typography className="mb-5">{t('organic_keywords')}</Typography>
            <ButtonExportExcel isLoading={model.isLoading.export} onClick={controller.handleExportExcel} totalKeywords={model.keywordsData?.total || 0} query={model.project || ""} />
          </Box>

          <TableComponent
            className='fullHeight'
            rows={model.keywordsData?.items}
            rowCount={model.keywordsData?.total || 0}
            columns={COLUMNS_PROJECT_OPPORTUNITY_KEYWORD(t)}
            loading={model.isLoading.keywords}
            paginationModel={model.paginationModel}
            onPaginationModelChange={model.setPaginationModel}
            sortModel={model.sortModel}
            onSortModelChange={model.setSortModel}
            sortingOrder={['asc', 'desc']}
            paginationMode="client"
            sortingMode="client"
            slots={{
              panel: () => (
                <div className='py-2'>
                  <ButtonGroup current={model.modeFilter} onChange={model.setModeFilter} suggestions={CONSTANTS.ALL_FILTER_MODE_OPPORTUNITY} />
                </div>
              )
            }}
            filterModel={{
              items: [
                {
                  field: 'contains_keyword',
                  operator: 'above',
                  value: model.modeFilter === 'all' ? undefined : model.modeFilter
                }
              ]
            }}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 }
              }
            }}
            pageSizeOptions={[10, 25, 50, 100]}
          />
        </PaperItem>
      </Grid2>
    </Grid2>
  )
}

export default OpportunityKeywordsView
